// extracted by mini-css-extract-plugin
export default {"position":"Autocomplet_position__iPbSc","autocomplet":"Autocomplet_autocomplet__2stnL","autocomplet__item":"Autocomplet_autocomplet__item__C+AhM"};